import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 2A1F0831-13CA-4419-BBD7-1F1FAF62A32B
 * name pause
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pause.svg
 * tags
 * - Home Automation 
 */
export const PauseIcon = createSvgIcon(<><path d="M14,19H18V5H14M6,19H10V5H6V19Z" /></>, 'PauseIcon');
export default PauseIcon